export default "/images/68baae3b8dbd3464f30e17e0482e5553.png";